import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const container = css`
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100%;
`;

export const placementThumbnail = css`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const noImageThumbnail = css`
  ${placementThumbnail};
  background-color: ${colors.gray[4]};
  height: 100%;
  cursor: default;
`;

export const thumbnail = css`
  ${placementThumbnail};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  flex: 1;
  cursor: pointer;
  background-color: ${colors.black.DEFAULT};
  img {
    object-fit: contain;
    object-position: center;
    height: 100%;
    width: 100%;
  }
`;

export const expandedThumbnailBackground = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1e2535;
  opacity: 0.4;
`;

const placement = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const collapsableThumbnailIcon = (size: 'md' | 'sm') => css`
  ${placement};
  fill-opacity: 0.9;
  ${
    size === 'sm' &&
    `
    width: 20px;
    height: 20px;
  `
  }
`;

const thumbnailBackground = (size: 'md' | 'sm') => css`
  width: ${size === 'sm' ? '24px' : '44px'};
  height: ${size === 'sm' ? '24px' : '44px'};
  border-radius: 50%;
  opacity: 0.9;
`;

const thumbnailIconSize = (size: 'md' | 'sm') => css`
  width: ${size === 'sm' ? '12px' : '22px'};
  height: ${size === 'sm' ? '12px' : '22px'};
`;

export const thumbnailIcon = (size: 'md' | 'sm') => css`
  ${placement};
  ${thumbnailBackground(size)};
  background-color: ${colors.black.DEFAULT};
  color: ${colors.white.DEFAULT};
  svg {
    ${placement};
    ${thumbnailIconSize(size)};
  }
`;

export const noImageThumbnailIcon = (size: 'md' | 'sm') => css`
  ${placement};
  ${thumbnailBackground(size)};
  background-color: ${colors.gray[3]};
  color: ${colors.gray[4]};
  svg {
    ${placement};
    ${thumbnailIconSize(size)};
  }
`;
